import React, { createContext, Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useAuth, useIntl } from 'hooks'
import { setTab } from 'features/auth/appSlice'
import {
    setPatient,
    setUIFilter as setPatientUiFilter,
    getPatientsWithSummary,
} from 'features/patients-list/patientSlice'
import {
    setCollection,
    setUIFilter as setCollectionUIFilter,
    getCollections,
} from 'features/collections-list/collectionSlice'
import Details from 'features/patient-details/Details'
import CollectionDetails from 'features/collection-details/CollectionDetails'
import FavoritesDetails from 'features/favorite/Details'
import SharedDetails from 'features/share-details/Details'
import Patients from 'features/patients-list/List'
import Collections from 'features/collections-list/List'
import './index.css'

export const PatientContext = createContext(null)
export const CollectionContext = createContext(null)

const PatientsCollections = () => {
    const { t } = useIntl()
    const dispatch = useDispatch()
    const history = useHistory()
    const { isAuthorized } = useAuth()

    const selectedPatient = useSelector(state => state.patients.selectedPatient)
    const selectedCollection = useSelector(state => state.collections.selectedCollection)
    const { zscTab } = useSelector(state => state.app)
    const [selectedTab, setSelectedTab] = useState(isAuthorized ? zscTab : 'collections')

    useEffect(() => {
        if (!isAuthorized) return

        const state = history.location.state
        if (state !== 'file-view') {
            dispatch(getPatientsWithSummary())
            dispatch(getCollections())
        } else {
            window.history.replaceState({}, document.title)
        }
        return () => {
            if (!isAuthorized) return

            const state = history.location.state
            if (state?.actionType === 'file-view') {
                dispatch(setTab(state.tab))
                if (state.tab === 'collections') {
                    dispatch(setCollection(state.id))
                    dispatch(setCollectionUIFilter(state.filter))
                }
                if (state.tab === 'patients') {
                    dispatch(setPatient(state.id))
                    dispatch(setPatientUiFilter(state.filter))
                }
            } else {
                dispatch(setTab('patients'))
                dispatch(setCollection(null))
                dispatch(setCollectionUIFilter('all'))
                dispatch(setPatient(null))
                dispatch(setPatientUiFilter('all'))
                // dispatch(resetAll())
                // dispatch(resetFilter())
            }
        }
    }, [])

    const handleTabSelection = tab => {
        if (!isAuthorized) return

        setSelectedTab(tab)
        dispatch(setPatientUiFilter('all'))
        dispatch(setCollectionUIFilter('all'))
    }

    return (
        <Fragment>
            <div className="sub-navigation">
                <div className="sub-navigation-content-wrapper">
                    <div className="tabs-wrapper">
                        <div className="tabs-container">
                            <div
                                className={` ${
                                    selectedTab === 'patients' ? 'selected-tab' : ''
                                } tab-patinet-title`}
                                onClick={() => handleTabSelection('patients')}
                            >
                                <span>{t('patients')}</span>
                            </div>
                            <div
                                className={` ${
                                    selectedTab === 'collections' ? 'selected-tab' : ''
                                } tab-collection-title`}
                                onClick={() => handleTabSelection('collections')}
                            >
                                <span>{t('collections')}</span>
                            </div>
                        </div>
                    </div>
                    {selectedTab === 'patients' ? (
                        <Patients selectedPatient={selectedPatient} />
                    ) : (
                        <Collections selectedCollection={selectedCollection} />
                    )}
                </div>
            </div>

            {selectedTab === 'patients' && isAuthorized ? (
                <PatientContext.Provider value={{ patient: selectedPatient }}>
                    <Details key={selectedPatient?.id} />
                </PatientContext.Provider>
            ) : (
                <CollectionContext.Provider value={{ collectionId: selectedCollection }}>
                    {selectedCollection === 'favorites' && isAuthorized && (
                        <FavoritesDetails key={selectedCollection} />
                    )}
                    {selectedCollection === 'shared' && <SharedDetails key={selectedCollection} />}
                    {!['favorites', 'shared'].includes(selectedCollection) && (
                        <CollectionDetails key={selectedCollection} />
                    )}
                </CollectionContext.Provider>
            )}
        </Fragment>
    )
}

export default PatientsCollections
